


export const corporateBlue = "#2f7bea" as string;
